import React from 'react'
import { withRouter, Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { resolveActiveMenuLink, stripLang } from './menuMatch'
import { MENU_BREADCRUMB } from './menuBreadcrumbMap'

// Larguras dos drawers (iguais ao material-styles) e altura da faixa.
const DRAWER_WIDTH = 240
const DRAWER_WIDTH_RIGHT = 350
const BAR_HEIGHT = 64      // altura da AppBar (mixins.toolbar desktop)
const BREADCRUMB_HEIGHT = 30

const MENU_LINKS = Object.keys(MENU_BREADCRUMB)

// Crumb dinâmico do recurso a partir da URL (zero-touch nas páginas):
//   /called-accompaniment/123 -> "#123"   |   *-registration -> "Adicionar"   |   *-edit -> "Editar"
const resolveResourceTail = (pathname, intl) => {
  const p = stripLang(pathname)
  const segs = p.split('/').filter(Boolean)
  const last = segs.length ? segs[segs.length - 1] : ''
  if (/^\d+$/.test(last)) return '#' + last
  if (p.endsWith('-registration')) return intl.formatMessage({ id: 'add' })
  if (p.endsWith('-edit')) return intl.formatMessage({ id: 'edit' })
  return null
}

const labelOf = (entry, key, altKey, intl) => {
  if (!entry) return null
  if (entry[key]) return intl.formatMessage({ id: entry[key] })
  if (entry[altKey]) return entry[altKey]
  return null
}

function AppBreadcrumb(props) {
  const { location, intl, headerMenu, actionsHeaderMenu, userSession } = props
  if (!location) return null

  const activeLink = resolveActiveMenuLink(location.pathname, MENU_LINKS)
  const entry = activeLink ? MENU_BREADCRUMB[activeLink] : null
  if (!entry) return null

  const lang = (location.pathname.split('/').filter(Boolean)[0]) || 'pt'
  const parentLabel = labelOf(entry, 'parentLabelId', 'parentLabel', intl)
  const itemLabel = labelOf(entry, 'labelId', 'label', intl)
  const tail = resolveResourceTail(location.pathname, intl)

  // Home navega para a página inicial do usuário (config startpage; fallback 'calleds').
  const startPage = (userSession && userSession.user && userSession.user.startpage) ? userSession.user.startpage : 'calleds'
  const homeTo = `/${lang}/${startPage}`

  const crumbs = []
  if (parentLabel) crumbs.push({ key: 'parent', label: parentLabel })
  if (itemLabel) crumbs.push({ key: 'item', label: itemLabel, to: tail ? `/${lang}${activeLink}` : null })
  if (tail) crumbs.push({ key: 'tail', label: tail })
  if (crumbs.length === 0) return null

  const leftOpen = !!(headerMenu && headerMenu.open)
  const rightOpen = !!(actionsHeaderMenu && actionsHeaderMenu.open)

  const sep = (
    <NavigateNextIcon style={{ fontSize: 16, color: 'var(--text-secondary, #9e9e9e)', flexShrink: 0, pointerEvents: 'none' }} />
  )
  // Elementos clicáveis reativam o ponteiro (a faixa em si é "transparente" a cliques).
  const clickable = { pointerEvents: 'auto' }
  const linkStyle = { ...clickable, color: 'var(--mexx-green-primary, #2979ff)', textDecoration: 'none', fontWeight: 500 }

  return (
    <>
      {/* Reserva a altura da faixa no conteúdo (o spacer drawerHeader lê esta var). Só existe
          enquanto há breadcrumb — telas sem item / menu novo não ganham gap. Assim a faixa
          (transparente) fica num respiro próprio no topo, sem sobrepor os primeiros componentes. */}
      <style>{`:root{--mexx-breadcrumb-height:${BREADCRUMB_HEIGHT}px;}`}</style>
      <nav
        aria-label="breadcrumb"
        style={{
          position: 'fixed',
          top: BAR_HEIGHT,
        left: leftOpen ? DRAWER_WIDTH : 0,
        right: rightOpen ? DRAWER_WIDTH_RIGHT : 0,
        height: BREADCRUMB_HEIGHT,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '0 20px',
        boxSizing: 'border-box',
        background: 'transparent',            // 100% transparente: não cobre o componente abaixo
        pointerEvents: 'none',                // cliques atravessam a faixa (só os links capturam)
        fontSize: 13,
        whiteSpace: 'nowrap',
        transition: 'left .2s ease, right .2s ease',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <Link to={homeTo} title="Início" style={{ ...clickable, display: 'inline-flex', alignItems: 'center' }}>
        <HomeOutlinedIcon style={{ fontSize: 18, color: 'var(--mexx-green-primary, #2979ff)', flexShrink: 0 }} />
      </Link>
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1
        return (
          <React.Fragment key={c.key}>
            {sep}
            {c.to && !isLast ? (
              <Link to={c.to} style={linkStyle}>
                {c.label}
              </Link>
            ) : (
              <span style={{ pointerEvents: 'none', color: isLast ? 'var(--text-primary, #37474f)' : 'var(--text-secondary, #757575)', fontWeight: isLast ? 600 : 500, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {c.label}
              </span>
            )}
          </React.Fragment>
        )
      })}
      </nav>
    </>
  )
}

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  actionsHeaderMenu: state.actionsHeaderMenu,
  userSession: state.userSession,
})

export default connect(mapStateToProps)(injectIntl(withRouter(AppBreadcrumb)))
